export const text = {
    // TODO: localize
    writeCaption: `Write a caption`,
};
